import { createContext, useContext } from 'react';

const ctx = createContext();

export const MediaContextProvider = ctx.Provider;

export const useMediaContext = () => {
  return useContext(ctx);
};
